<template>
  <v-card class="black !h-full !border-0" tile>
    <v-btn absolute icon dark @click="$emit('nav-close')" large :color="colorAsRoute" right class="top-6">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-list class="!pt-20 overflow-y-auto listAdjuster text-lg">
      <ProfileFilter :dialog="dialog" @close-dialog="searchFilterHandler()" />
      <v-list-item class="my-3" @click.prevent="homeSetHandler()"
        :to="{ name: 'Profiles', params: { type: routeLink } }">
        <v-btn class="mx-2  btn-nav-menu" icon dark large>
          <img :src="require(`@/assets/img/nav-icons/${routeLink}/home.png`)" alt />
        </v-btn>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Home</h1>
      </v-list-item>
      <v-list-item @click.prevent="filterDialogToggle" class="my-3">
        <!-- <v-btn class="mx-2  btn-nav-menu" icon dark large>
          <img :src="require(`@/assets/img/nav-icons/${routeLink}/search.png`)" alt />
        </v-btn>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Search</h1> -->
        <v-badge v-if="!premium" overlap right bordered icon="mdi-crown-outline" :color="colorAsRoute" avatar dark 
        :class="` font-Nunito ${routeLink}_text_color `" offset-x="22" offset-y="13">
          <v-avatar rounded size="44" class="mx-2">
            <span :class="`h-full w-full !p-[2px]  ${routeLink}_btn_color rounded-full relative`">
              <v-btn fab width="40" height="40" :color="`${routeLink}_btn_bg`" dark  class=" " elevation="0">
                <Icon class="text-3xl font-semibold " :color="routeLink == 'gay' ? 'white' : 'black'"
                  icon="ph:magnifying-glass-light" />
              </v-btn>
            </span>
          </v-avatar>
        </v-badge>
        <v-avatar v-else rounded size="44" class="mx-2">
          <span :class="`h-full w-full !p-[2px]  ${routeLink}_btn_color rounded-full relative`">
            <v-btn fab width="40" height="40" :color="`${routeLink}_btn_bg`" dark  class=" " elevation="0">
              <Icon class="text-3xl font-semibold " :color="routeLink == 'gay' ? 'white' : 'black'"
                icon="ph:magnifying-glass-light" />
            </v-btn>
          </span>
        </v-avatar>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Search</h1>
      </v-list-item>
      <v-list-item class="my-3" @click.prevent="goToNotifications"
        :to="{ name: 'Notifications', params: { type: routeLink } }">
        <v-btn class="mx-2  btn-nav-menu" icon dark large>
          <img :src="require(`@/assets/img/nav-icons/${routeLink}/ring.png`)" alt />
        </v-btn>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Notifcations</h1>
      </v-list-item>
      <v-list-item class="my-3" @click.prevent="goToNotifications"
        :to="{ name: 'Chats', params: { type: routeLink } }">
        <v-btn class="mx-2  btn-nav-menu" icon dark large>
          <img :src="require(`@/assets/img/nav-icons/${routeLink}/comment.png`)" alt />
        </v-btn>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Chats</h1>
      </v-list-item>
      <v-list-item @click.prevent="$store.dispatch('changePom', true) , $emit('nav-close')" class="my-3">
        <v-avatar rounded size="44" class="mx-2">
          <span :class="`h-full w-full !p-[2px]  ${routeLink}_btn_color rounded-full relative`">
            <v-btn fab width="40" height="40" :color="`${routeLink}_btn_bg`" dark  class=" " elevation="0">
              <Icon class="text-3xl font-semibold " :color="routeLink == 'gay' ? 'white' : 'black'"
                icon="ph:trophy-light" />
            </v-btn>
          </span>
        </v-avatar>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Profile of the Month</h1>
      </v-list-item>
      <v-list-item class="my-3" @click.prevent="goToSettings"
        :to="{ name: 'SelectedSetting', params: { type: routeLink ,setting: 'PaymentDetails'  } }">
        <v-btn class="mx-2  btn-nav-menu" icon dark large>
          <img :src="require(`@/assets/img/nav-icons/${routeLink}/setting.png`)" alt />
        </v-btn>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Setting</h1>
      </v-list-item>
      <v-list-item @click.prevent="logOutUser" class="my-3">
        <v-btn class="mx-2  btn-nav-menu" icon dark large>
          <img :src="require(`@/assets/img/nav-icons/${routeLink}/logout.png`)" alt />
        </v-btn>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Log out</h1>
      </v-list-item>
      <v-list-item @click.prevent="$emit('show-tutorial')" class="my-3">
        <!-- <v-btn class="mx-2 " icon dark large :color="`${routeType}primary`">
          <v-icon>mdi-school-outline</v-icon>
        </v-btn> -->
        <v-avatar rounded size="44" class="mx-2">
          <span :class="`h-full w-full !p-[2px]  ${routeLink}_btn_color rounded-full relative`">
            <v-btn fab width="40" height="40" :color="`${routeLink}_btn_bg`" dark  class=" " elevation="0">
              <Icon class="text-3xl font-semibold " :color="routeLink == 'gay' ? 'white' : 'black'"
                icon="material-symbols:school-outline-rounded" />
            </v-btn>
          </span>
        </v-avatar>
        <h1 :class="`pl-5 ${routeLink}_color_text`">Tutorial</h1>
      </v-list-item>
    </v-list>
    <v-spacer></v-spacer>
    <SpotifyPlayer />
    <!-- <SpotifyButton v-if="!premium && isLoggedIn && !isMobile" />
    <v-container v-if="isLoggedIn && premium" fluid class="floatingPlayer !p-0 bottom-0">
      <MiniPlayer />
    </v-container> -->
    <SubscribePremiumDialog />
  </v-card>
</template>

<script>
import ProfileFilter from "./ProfileFilter.vue";
import MiniPlayer from "../../components/musicplayer/MiniPlayer.vue";
import NavButton from "../NavButton.vue";
import { Icon } from "@iconify/vue2";
import SpotifyPlayer from "../premium/SpotifyPlayer.vue";
import SubscribePremiumDialog from "../settings/SubscribePremiumDialog.vue";


export default {
  name: "MobileNav",
  components: {
    ProfileFilter,
    MiniPlayer,
    NavButton,
    Icon,
    SpotifyPlayer,
    SubscribePremiumDialog
},
  data() {
    return {
      messages: [],
      dialog: false,
      premiumDialog: false,
    };
  },
  computed: {
    premium() {
      return this.$store.getters.isPremium;
    },
    colorAsRoute() {
      if (this.routeLink == 'straight') {
        return '#a07a1d'
      }
      else if (this.routeLink == 'gay') {
        return '#88c3fa'
      }
      else if (this.routeLink == 'lesbian') {
        return '#9e2eec'
      }
    }
  },
  methods: {
    goToSettings() {
      this.$emit('nav-close')
      this.$store.dispatch("setView", {
        left: "none",
        center: "block",
        right: "none",
      });
    },
    goToNotifications() {
      this.$emit('nav-close')
      this.$store.dispatch("setView", {
        left: "none",
        center: "none",
        right: "block",
      });
    },
    searchFilterHandler(){
      this.dialog = false;
      this.$emit('nav-close')
      if(this.$route.name !== 'Profiles'){
        this.$router.push({name : 'Profiles'})
      }
      this.setCenterView()
    },
    homeSetHandler() {
      this.$emit('nav-close')
      this.setCenterView()
    },
    filterDialogToggle() {
      if (this.$store.getters.isPremium) {
        this.dialog = true;
      } else {
        this.openSubscribeToPremiumDialog();
      }
    },
    messagesHandler(data) {
      this.messages.push(JSON.stringify(data));
    },
    // premiumDialogFn() {
    //   this.premiumDialog = true
    // },
    setUserProfile() {
      this.premiumDialog = false,
        this.$store.dispatch("premium")
    },
    async logOutUser() {
      await this.$store.dispatch("LogOut");
      this.$emit('nav-close')

      this.setCenterView()
      this.$router.push("/login");
    },
    packageNav() {
      this.$router.push({ name: "Plan" });
      this.$emit("nav-close");
    },
  },
  created() {
    const pusher = new Pusher("5fe0e88120539c62b974", {
      cluster: "mt1",
    });
    const channel = pusher.subscribe("my-channel");
    channel.bind("my-event", (data) => {
      this.messages.push(data);
    });
  },
};
</script>

<style scoped>
.listAdjuster {
  background: transparent !important;
  /* position: absolute; */
  left: 2%;
  /* top: 50%; */
  /* transform: translate(0%, -50%); */
}

.straight_text_color {

  color: #a07a1d !important;
}

.gay_text_color {
  color: #88c3fa !important;
}

.lesbian_text_color {
  color: #9e2eec !important;
}

.v-list-item img {
  width: 45%;
  align-items: center;
  justify-content: center;
  display: flex;
  margin: auto;
}

.floatingPlayer {
  position: relative;
  z-index: 98;
  bottom: 0%;
  right: 0%;
  max-width: 100%;
  padding: 0;
}

.straight_btn_bg {
  background: rgb(228, 192, 104);

  background: linear-gradient(135deg, rgba(228, 192, 104, 1) 7%, rgb(182 149 61) 33%, rgba(202, 174, 113, 1) 55%, rgba(166, 133, 43, 1) 80%);
}

.gay_btn_bg {
  background-color: #0063a2 !important;
}

.lesbian_btn_bg {
  background: rgb(122, 174, 245);
  background: -moz-linear-gradient(133deg, rgba(122, 174, 245, 1) 25%, rgba(172, 208, 244, 1) 50%, rgba(122, 188, 244, 1) 75%);
  background: -webkit-linear-gradient(133deg, rgba(122, 174, 245, 1) 25%, rgba(172, 208, 244, 1) 50%, rgba(122, 188, 244, 1) 75%);
  background: linear-gradient(133deg, rgba(122, 174, 245, 1) 25%, rgba(172, 208, 244, 1) 50%, rgba(122, 188, 244, 1) 75%);
}

.gay_btn_color {
  background: rgb(0, 16, 245);
  background: -moz-linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%);
  background: -webkit-linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%);
  background: linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%);
}

.lesbian_btn_color {
  background: #8701b9;
  /* background: -moz-linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%);
  background: -webkit-linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%);
  background: linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%); */
}

.straight_btn_color {
  background: rgb(228, 192, 104);

  background: linear-gradient(83deg, rgba(228, 192, 104, 1) 0%, rgba(167, 132, 40, 1) 22%, rgba(202, 174, 113, 1) 55%, rgba(166, 133, 43, 1) 85%);
}

.straight_color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(345deg,
      rgb(97 69 0) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(90 64 0 / 97%) 100%);
}

.lesbian_color {
  background: rgb(126, 0, 157);
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
}

.gay_color {
  background: rgb(0, 240, 255);
  background: linear-gradient(39deg,
      rgba(0, 240, 255, 1) 0%,
      rgba(0, 156, 255, 1) 100%);
}
button.btn-nav-menu {
  background-color: transparent !important;
}

/* .mdi-close::before {
  content: "\F0156";
  color: #000000;
  margin-top: 80px;
  margin-right: 30px;
  background: #a07a1d;
  padding: 5px;
} */
</style>
